module.exports = __webpack_public_path__ + "img/loading.ebd6ca0e.gif";